var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, Utils, CustomElement, Watch, PropertyConverters, Components, CustomElementUtils } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
let PacemSidebarElement = class PacemSidebarElement extends Components.PacemElement {
    constructor() {
        super(...arguments);
        this.open = false;
        this.synchronizeShell = true;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'open':
            case 'synchronizeShell':
                this._sync();
                break;
        }
    }
    disconnectedCallback() {
        this._sync(false);
        super.disconnectedCallback();
    }
    _sync(val = this.open) {
        const shell = this.#shell;
        if (this.synchronizeShell) {
            Utils.addClass(this, 'sidebar-sync');
            Utils.addClass(shell, PCSS + (val === true ? '-sidebar-open' : '-sidebar-close'));
            Utils.removeClass(shell, PCSS + (val === true ? '-sidebar-close' : '-sidebar-open'));
        }
        else {
            Utils.removeClass(this, 'sidebar-sync');
            Utils.removeClass(shell, PCSS + '-sidebar-close ' + PCSS + '-sidebar-open');
        }
    }
    #shell;
    connectedCallback() {
        super.connectedCallback();
        this.#shell = CustomElementUtils.findAncestorShell(this);
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemSidebarElement.prototype, "open", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemSidebarElement.prototype, "synchronizeShell", void 0);
PacemSidebarElement = __decorate([
    CustomElement({
        tagName: P + '-sidebar', template: `<${P}-panel class="sidebar-drawer" part="drawer" css-part="{{ { 'open': :host.open } }}" css-class="{{ {'open': :host.open } }}">
    <slot></slot>
</${P}-panel>`,
        shadow: true
    })
], PacemSidebarElement);
export { PacemSidebarElement };
